var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CloudCheck"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.00008 8C5.00008 7.0111 5.29332 6.0444 5.84273 5.22215C6.39214 4.39991 7.17303 3.75904 8.08666 3.3806C9.00029 3.00217 10.0056 2.90315 10.9755 3.09608C11.9454 3.289 12.8363 3.76521 13.5356 4.46447C14.2349 5.16373 14.7111 6.05465 14.904 7.02455C15.0969 7.99446 14.9979 8.99979 14.6195 9.91342C14.241 10.827 13.6002 11.6079 12.7779 12.1573C11.9557 12.7068 10.989 13 10.0001 13H4.50008C4.0038 12.9994 3.51333 12.8932 3.06121 12.6886C2.60909 12.484 2.20565 12.1855 1.87767 11.8131C1.54969 11.4406 1.30467 11.0027 1.15886 10.5283C1.01306 10.0539 0.969798 9.55399 1.03196 9.06162C1.09412 8.56925 1.26028 8.09573 1.51941 7.67248C1.77854 7.24923 2.12471 6.88593 2.53497 6.60668C2.94522 6.32743 3.41017 6.13861 3.89896 6.05277C4.38776 5.96692 4.88922 5.986 5.37008 6.10875",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.5 8.5L9 10L12 7",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudCheck);
export default __webpack_public_path__ + "static/media/CloudCheck.3ff98d55.svg";
export { ForwardRef as ReactComponent };